import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LandingPage.css';
import { Footer, Header } from '../basicComponent/Basic';
import { motion } from "framer-motion"; // Import Framer Motion
const LandingPage = () => {
  const navigate = useNavigate();

  const handleRegisterClick = () => {
    navigate('/feefix/registerOrganization'); // Navigate to registration page
  };

  return (
    <div className="landing-page">
      <Header />
      <motion.section
        className="hero-section"
        initial={{ opacity: 0, y: 50 }} // Start with fade in and slide
        animate={{ opacity: 1, y: 0 }} // Animate to visible
        transition={{ duration: 1 }} // Set duration for smoothness
      >
      {/* Hero Section */}
      <section className="hero-section">
        <div className="container hero-content">
          <h1 className="typing-text">Empower Your Institution with ManageEdu</h1>
          <p className="hero-description">
            A complete solution to streamline student fee management and course enrollments. Focus on education while we handle the rest.
          </p>
          <button className="cta-btn" onClick={handleRegisterClick}>
            Register Your Organization
          </button>
        </div>
      </section>
      </motion.section>
      {/* How It Works Section */}
      <section id="how-it-works" className="how-it-works-section">
        <div className="container">
          <h2 className="section-title">How It Works</h2>
          <div className="steps">
            <div className="step">
              <h3>Step 1: Register</h3>
              <p>Sign up your institution in minutes and get started right away.</p>
            </div>
            <div className="step">
              <h3>Step 2: Add Courses & Students</h3>
              <p>Easily manage courses and students in a centralized system.</p>
            </div>
            <div className="step">
              <h3>Step 3: Track Payments</h3>
              <p>Monitor payments, send reminders, and maintain comprehensive records.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className="features-section">
        <div className="container">
          <h2 className="section-title">Key Features</h2>
          <div className="features-grid">
            <div className="feature-item">
              <h4>Automated Reminders</h4>
              <p>Send fee reminders automatically to parents and students.</p>
            </div>
            <div className="feature-item">
              <h4>Student Management</h4>
              <p>Keep track of student enrollment and attendance with ease.</p>
            </div>
            <div className="feature-item">
              <h4>Customizable Options</h4>
              <p>Adapt ManageEdu to the unique needs of your organization.</p>
            </div>
            <div className="feature-item">
              <h4>Detailed Reports</h4>
              <p>Generate insightful reports to track payments and course enrollments.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section id="testimonials" className="testimonials-section">
        <div className="container">
          <h2 className="section-title">What Our Clients Say</h2>
          <div className="testimonials-grid">
            <div className="testimonial-item">
              <p>"ManageEdu has simplified our fee management process. It's intuitive and has saved us so much time!"</p>
              <p>- Sarah, School Admin</p>
            </div>
            <div className="testimonial-item">
              <p>"The automated fee reminders are a fantastic feature, making our communication with parents much easier."</p>
              <p>- Ahmed, Coaching Center Owner</p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="cta-section">
        <div className="container">
          <h2 className="section-title">Ready to Take Control of Your Fee Management?</h2>
          <p>Join the many educational institutions using ManageEdu to automate their processes and reduce administrative work.</p>
          <button className="cta-btn" onClick={handleRegisterClick}>
            Get Started
          </button>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default LandingPage;
